import React from 'react';
import classNames from 'classnames';

export default class PreviewThumbnail extends React.Component {
  getTrimOffset (streamURL) {
      const parsedStreamURL = new URL(streamURL);
      const paths = parsedStreamURL.pathname.split('/');
      const streamID = paths[paths.length - 2];
      return streamID ? parseInt(streamID.split('-')[1]) || 0 : 0;
  }
  render() {
    const { mouseTime, className, storyboard, isLive, player } = this.props;
    const trimOffset = player && player.hls && player.hls.url ? this.getTrimOffset(player.hls.url) : 0;

    if (!mouseTime.time)
      return null;

    if (isLive)
      return null;

    if (typeof storyboard === 'undefined')
      return null;

    const { tileHeight, tileWidth, filePathFormat, columnsPerRow, rowsPerFile, tileInterval } = storyboard;
    const storyboardDuration = rowsPerFile * columnsPerRow * tileInterval;
    const storyboardIndex = Math.ceil((mouseTime.time + trimOffset) / storyboardDuration);
    const tileIndex = Math.floor((mouseTime.time + trimOffset - (storyboardIndex - 1) * storyboardDuration) / tileInterval);
    const columnTop = Math.floor(tileIndex / columnsPerRow) * -tileHeight;
    const columnLeft = Math.floor(tileIndex % columnsPerRow) * -tileWidth;

    return !!storyboard &&
          <div
              className={classNames('video-react-thumbnail-preview', className)}
              style={{
                left: `${mouseTime.position}px`,
                height: `${tileHeight}px`,
                width: `${tileWidth}px`,
                transform: `translate(${-tileWidth/2}px, ${-tileHeight}px)`,
                backgroundImage: `url(${filePathFormat.replace('%d', storyboardIndex)})`,
                backgroundRepeat: `no-repeat`,
                backgroundPosition: `${columnLeft}px ${columnTop}px`,
              }}
          />
  }
}
